import React from "react";
import { Progress } from "antd";
import FlowCard from "../../../../../../CommonComponents/FlowCard/FlowCard";
import {
  DataHeading,
  DataValue,
  SemiDarkerDivider,
  NoData,
  NoDataDiv
} from "../../../../../../CommonComponents/commonStyles";
import colorMapping from "../../../../../../CommonComponents/colorMapping";
import { LinkNavigatorButton } from "../../../../../../CommonComponents/CTA/Buttons";
import Chart from "../Chart/Chart";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { WhiteGradient } from "../../../../../../CommonComponents/commonStyles";
import {
  TableCircleName,
  ChartPlacement,
  InvestmentPerformanceDiv,
  PerformanceData,
  CategoryName,
  LinkDiv
} from "./styles";
import { initiateTracking, formatAmount } from '../../../../../../utils/commonUtil';

import tooltipIcon from '../../../../../../assets/icons/shape.svg';
import { TooltipCircle,MarketMovementTooltip } from '../Tooltip/styles';
import moment from "moment";
import PropTypes from 'prop-types';
import { replaceSelect } from '../../../../../../utils/replacer';

const accountType = "STANDARD";

class InvestmentPerformanceMobile extends React.Component {
  state = {
    ps: [],
    pb: [],
    vd: []
  };
  componentDidMount() {
    let investmentPoolsTableData_ps = [];
    let investmentPoolsTableData_pb = [];
    let investmentPoolsTableData_vd = [];

    if (accountType === "STANDARD") {
      this.props.accData.forEach((item) => {
        if (
          item.poolCategory === "PORTFOLIO SOLUTIONS" &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_ps.push(item);
        } else if (
          (item.poolCategory === "BUILDING BLOCKS" ||
            item.poolCategory === "INTERNATIONAL TILTS" ||
            item.poolCategory === "SPECIFIC REGIONS" ||
            item.poolCategory === "BALANCED FUNDS") &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_pb.push(item);
        } else if (
          item.poolCategory === "VALUES DRIVEN INVESTMENTS" &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_vd.push(item);
        }
      });
    } else if (accountType === "SELECT") {
      this.props.accData.forEach(item => {
        if (item.poolCategory === "PORTFOLIO SOLUTIONS") {
          investmentPoolsTableData_ps.push(item);
        } else if (
          (item.poolCategory === "BUILDING BLOCKS" ||
            item.poolCategory === "INTERNATIONAL TILTS" ||
            item.poolCategory === "SPECIFIC REGIONS" ||
            item.poolCategory === "BALANCED FUNDS") &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_pb.push(item);
        } else if (
          item.poolCategory === "VALUES DRIVEN INVESTMENTS" &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_vd.push(item);
        }
      });
    }
    this.setState({
      ps: investmentPoolsTableData_ps,
      pb: [...investmentPoolsTableData_pb],
      vd: [...investmentPoolsTableData_vd]
    });
  }
  colorMappingData = data => {
    return colorMapping[data];
  };

  renderProgressGrid = pool => {
    let Assetmix_Cal = (pool.currentBalance / this.props.main_accbalance) * 100;
    let Assetmix_value = parseFloat(Assetmix_Cal.toFixed([2]))
      return (
        <Progress
          status="normal"
          type="circle"
          percent={Assetmix_value}
          strokeWidth={10}
          width={60}
          strokeLinecap="square"
          strokeColor={this.colorMappingData(pool.poolName)}
          format={Assetmix_value === 100 ? () => "100%" : () => Assetmix_Cal.toFixed([2])+"%"}
        />
      );
  };

  renderTitleGrid = pool => {
    return <TableCircleName>{replaceSelect(pool.poolName)}</TableCircleName>;
  };
  renderAmountGrid = ({ pool, gridName, label }) => {
    return (
      <>
        <DataHeading>{label}
        {label==="NAV"?<MarketMovementTooltip
        overlayClassName='market-movemet-tooltip tolltip_arrow'
        placement='bottomRight'
        title={moment(pool.dateOfPricePerUnit).format('LL')}
        autoAdjustOverflow={true}
      >
        <TooltipCircle src={tooltipIcon} alt = "tooltipIcon"/>
      </MarketMovementTooltip>:null}
        </DataHeading>
        
        {pool[gridName] !== null ? (
          <DataValue>
            {formatAmount(pool[gridName])}
          </DataValue>
        ) : (
            <DataValue> &mdash; </DataValue>
          )}
      </>
    );
  };
  renderUnitGrid = ({ pool, gridName, label }) => {
    return (
      <>
        <DataHeading>{label}</DataHeading>
        {pool[gridName] !== null ? (
          <DataValue>
            {Number(pool[gridName]).toLocaleString(undefined, {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4
            })}
          </DataValue>
        ) : (
            <DataValue> &mdash; </DataValue>
          )}
      </>
    );
  };
  renderChartGrid = pool => {
    return (
      <>
        <DataHeading>Historical NAV</DataHeading>
        <ChartPlacement>
          <Chart
            chartData={pool.prices}
            strokeColor={this.colorMappingData(pool.poolName)}
            width="140"
            height="65"
          />
        </ChartPlacement>
      </>
    );
  };
  gotoOptionDetails = (poolName, tab, buttonName) => {
    initiateTracking('learnMore', 'Investment Overview', poolName, buttonName);
    this.props.history.push({
      pathname: '/investments/details',
      state: {
        tabIndex: tab,
        poolName
      }
    });
  }
  renderLink = (poolName, tab) => {
    let buttonName = "Learn More";
    const LCP = "Low Carbon Global Equity";
    return <LinkDiv><LinkNavigatorButton styling={`${poolName === LCP ? 'display-none' : '' }`}  clicked={() => this.gotoOptionDetails(poolName, tab, buttonName)} {...{buttonName}} /></LinkDiv>;
  };

  styleConfig = () => {
    return {
      alternatingBg: false,
      cardBorder: false,
      cardPadding: false
    };
  };

  destObj = (pool, index, tab) => {
    return [
      {
        name: "progress",
        gridWidth: "30",
        type: "TitleGrid",
        render: this.renderProgressGrid(pool),
        noBorderBottom: true,
        ptop: false,
        pbottom: true
      },
      {
        name: "investmentOption",
        gridWidth: "70",
        type: "TitleGrid",
        render: this.renderTitleGrid(pool),
        noBorderBottom: true,
        ptop: false,
        pbottom: true
      },
      {
        name: "currentNAV",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderAmountGrid({
          pool,
          gridName: "currentNAV",
          label: "NAV"
        }),
        ptop: true,
        pbottom: true
      },
      {
        name: "currentUnits",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderUnitGrid({
          pool,
          gridName: "currentUnits",
          label: "Units"
        }),
        ptop: true,
        pbottom: true
      },
      {
        name: "marketValue",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderAmountGrid({
          pool,
          gridName: "currentBalance",
          label: "Market value"
        }),
        ptop: true,
        pbottom: true
      },
      {
        name: "chartData",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderChartGrid(pool),
        ptop: true,
        pbottom: false
      },
      {
        name: "link",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderLink(pool.poolName, tab),
        noBorderBottom: true,
        ptop: false,
        pbottom: false
      }
    ];
  };
  render() {
    const { isLoadingAccount } = this.props;
    const { ps, pb, vd } = this.state;
    if (isLoadingAccount) return <Preloader />;
    return ps.length === 0 && pb.length === 0 && vd.length === 0 ? (
      <NoDataDiv className="no-data mb-50">
        <NoData>
          You currently have no investment performance history.
        </NoData>
      </NoDataDiv>
    ) : (
        <InvestmentPerformanceDiv>
          <PerformanceData>
            {pb.length > 0 && <CategoryName>Portfolio Builders</CategoryName>}
            {pb.length > 0 &&
              pb.map((pool, index) => (
                <>
                  <FlowCard
                    key={index}
                    cardConfig={this.destObj(pool, index, 3)}
                    index={index}
                    styleConfig={this.styleConfig()}
                  />
                  <SemiDarkerDivider />
                </>
              ))}
            {ps.length > 0 && (
              <CategoryName className="mt0">Portfolio Solutions</CategoryName>
            )}
            {ps.length > 0 &&
              ps.map((pool, index) => (
                <>
                  <FlowCard
                    key={index}
                    cardConfig={this.destObj(pool, index, 2)}
                    index={index}
                    styleConfig={this.styleConfig()}
                  />
                  <SemiDarkerDivider />
                </>
              ))}

            {vd.length > 0 && (
              <CategoryName>Value Driven Investments</CategoryName>
            )}
            {vd.length > 0 &&
              vd.map((pool, index) => (
                <>
                  <FlowCard
                    key={index}
                    cardConfig={this.destObj(pool, index, 4)}
                    index={index}
                    styleConfig={this.styleConfig()}
                  />
                  <SemiDarkerDivider
                    className={
                      index === vd.length - 1 ? "display-none" : "mt-md-1-25 "
                    }
                  />
                </>
              ))}
          </PerformanceData>
          <WhiteGradient />
        </InvestmentPerformanceDiv>
      );
  }
}
InvestmentPerformanceMobile.propTypes = {
  ps: PropTypes.array,
  pd: PropTypes.array,
  vd: PropTypes.array,
  investmentPoolsTableData_ps: PropTypes.array,
  investmentPoolsTableData_pb: PropTypes.array,
  investmentPoolsTableData_vd: PropTypes.array,
  poolCategory: PropTypes.string,
  renderProgressGrid: PropTypes.func,
  Assetmix_Cal: PropTypes.number,
  Assetmix_value: PropTypes.number,
  styleConfig: PropTypes.func,
  renderTitleGrid: PropTypes.func,
  renderAmountGrid: PropTypes.func,
  renderUnitGrid: PropTypes.string,
  renderChartGrid: PropTypes.func,
  gotoOptionDetails: PropTypes.func,
  renderLink: PropTypes.func,
  main_accbalance: PropTypes.number,
  isLoadingAccount: PropTypes.bool,
  accountType: PropTypes.string
}

export default InvestmentPerformanceMobile;
